import {
  Heading,
  lgBumps,
  mdBumps,
  Notification,
  SecondaryButton,
  Typo,
} from '@wrisk/ui-components'
import { isAxiosError } from 'axios'
import React, { FunctionComponent, useCallback } from 'react'
import { useNavigate } from 'react-router'

import { TKey, useWriskTranslation } from '../../infrastructure/internationalisation'
import { AppPath } from '../AppPath'
import { AnonymousPrincipal } from '../authentication'
import { FullPage } from '../templates'

export interface RetrieveTokenErrorProps {
  principal: AnonymousPrincipal
  error: Error
}

const tKey = TKey('pages.retrieve-token-error')

export const RetrieveTokenError: FunctionComponent<RetrieveTokenErrorProps> = ({
  error,
}) => {
  const { t } = useWriskTranslation()

  const navigate = useNavigate()

  const status = isAxiosError(error) ? error.status?.toString() ?? 'unknown' : 'unknown'

  const handleAction = useCallback(() => {
    navigate(isAxiosError(error) && error.status === 409 ? AppPath.SIGN_IN : AppPath.HOME)
  }, [error])

  return (
    <FullPage
      pageId='retrieve-token-error-page'
      header={t([tKey('errors', status, 'header'), tKey('default', 'header')])}
      subheader={t([tKey('errors', status, 'subheader'), tKey('default', 'subheader')])}
    >
      <Notification
        type='standalone'
        rowGap={mdBumps}
        p={lgBumps}
        flexDirection='column'
        alignItems='flex-start'
        justifyContent='flex-start'
      >
        <Heading typoSize='md'>
          {t([
            tKey('errors', status, 'notification', 'header'),
            tKey('default', 'notification', 'header'),
          ])}
        </Heading>
        <Typo>
          {t([
            tKey('errors', status, 'notification', 'content'),
            tKey('default', 'notification', 'content'),
          ])}
        </Typo>
        <SecondaryButton onClick={handleAction}>
          {t([
            tKey('errors', status, 'actions', 'continue'),
            tKey('default', 'actions', 'continue'),
          ])}
        </SecondaryButton>
      </Notification>
    </FullPage>
  )
}
